module.exports = __webpack_public_path__ + "static/media/nonord-c-13.ec3cbf62.mp3";